module.exports = __webpack_public_path__ + "static/img/function_point.c177568.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/function_point.png
// module id = 2CYL
// module chunks = 37